/** Um campo obrigatório de formulário e se já foi preenchido. */
export interface RequiredField {
  /** O rótulo que a pessoa vê no formulário (sem o asterisco). */
  label: string;
  filled: boolean;
}

/** Rótulos dos campos ainda vazios, na ordem em que foram declarados. */
export function missingFields(fields: readonly RequiredField[]): string[] {
  return fields.filter((field) => !field.filled).map((field) => field.label);
}

/** Diz por que o botão de cadastrar está desabilitado.
 *
 * A lista de campos é a MESMA que o formulário usa pra desabilitar o botão
 * e pra recusar no handler (`missingFields(...).length > 0`): é isso que
 * impede o aviso e o botão de discordarem. Não é erro — é orientação —,
 * então usa o tom de texto auxiliar (`form-hint`), e some quando nada falta.
 */
export function RequiredFieldsHint({
  fields,
  editing = false,
}: {
  fields: readonly RequiredField[];
  editing?: boolean;
}) {
  const missing = missingFields(fields);
  if (missing.length === 0) return null;
  return (
    <small className="form-hint" role="note">
      {editing ? "Preencha para salvar" : "Preencha para cadastrar"}: {missing.join(", ")}
    </small>
  );
}
